import { GenericStatus } from "./props";
import { faCheckCircle, faXmarkCircle, faClock } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const CompanyStatus: GenericStatus[] = [
    {key: "pending_verification", text: "Pending approval", icon: faClock as IconProp, tagVariant: 'warning'},
    {key: "documents_verified", text: "Documents verified", icon: faCheckCircle as IconProp, tagVariant: 'primary'},
    {key: "documents_rejected", text: "Documents rejected", icon: faXmarkCircle as IconProp, tagVariant: 'error'},
    {key: "approved", text: "Approved", icon: faCheckCircle as IconProp, tagVariant: 'success'},
    {key: "rejected", text: "Rejected", icon: faXmarkCircle as IconProp, tagVariant: 'error'}
]

export default CompanyStatus;